import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { useContent } from "@/context/ContentContext";
import { PageHeader } from "@/components/PageHeader";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Users } from "lucide-react";
import RichText, { isHtml } from "@/components/RichText";

const DEFAULT_HERO = "https://static.prod-images.emergentagent.com/jobs/69bc8a3c-ed6c-4b85-a9a2-ec966ad0ef18/images/78eda5f328f50eb20a2ff4a10becaf2afb55ed3be29bd8763a6596148c7e843b.jpeg";

export default function Organy() {
  const { t } = useContent();
  const [members, setMembers] = useState([]);

  useEffect(() => {
    api.get("/members").then((r) => setMembers(r.data)).catch(() => {});
  }, []);

  const grouped = members.reduce((acc, m) => {
    const k = m.body_name || m.role || "Organy";
    (acc[k] = acc[k] || []).push(m);
    return acc;
  }, {});

  return (
    <div>
      <PageHeader label="Struktura Izby" title="Organy Izby Gospodarczej" subtitle={t("organy_intro")} bgImage={t("organy_hero_image") ? fileUrl(t("organy_hero_image")) : DEFAULT_HERO} />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        {Object.entries(grouped).map(([body, list]) => (
          <div key={body} className="mb-14">
            <div className="mb-6 flex items-center gap-3">
              <Users className="h-5 w-5 text-ztk-blue" />
              <h2 className="font-display text-2xl font-bold text-ztk-navy dark:text-white">{body}</h2>
              <div className="h-px flex-1 bg-border" />
            </div>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {list.map((m) => (
                <div
                  key={m.id}
                  data-testid={`organ-member-${m.id}`}
                  className="flex gap-4 rounded-2xl border border-border bg-card p-6 transition-all hover:border-ztk-blue/40 hover:shadow-lg"
                >
                  {m.image ? (
                    <img src={fileUrl(m.image)} alt={m.name} className="h-16 w-16 rounded-xl object-cover" />
                  ) : (
                    <Avatar className="h-16 w-16 rounded-xl">
                      <AvatarFallback className="rounded-xl bg-ztk-blue/10 font-display text-lg font-bold text-ztk-blue">
                        {m.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}
                      </AvatarFallback>
                    </Avatar>
                  )}
                  <div>
                    <h3 className="font-display font-semibold text-ztk-navy dark:text-white">{m.name}</h3>
                    <p className="text-sm font-medium text-ztk-blue">{m.role}</p>
                    {isHtml(m.description)
                      ? <RichText html={m.description} className="mt-1.5 text-sm text-muted-foreground" />
                      : <p className="mt-1.5 text-sm text-muted-foreground">{m.description}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
